import React from "react";
import Grid from "@material-ui/core/Grid";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";

const GuaranteeForChange = (props) => {
    return (
        <React.Fragment>
            {props.messagesGrowl}
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SubtitleLabel header="Garantías Asignadas" isBold={true}/>
                </Grid>
                <Grid item xs={12}>
                    <DataTable
                        value={props.guaranteeList}
                        footerColumnGroup={props.footerColumnGroup}
                        resizableColumns={true}
                        columnResizeMode={"fit"}
                        scrollable={true}
                        scrollHeight="400px"
                    >
                        <Column
                            field="emisora"
                            header="Emisora"
                            style={{textAlign: 'left'}}
                            sortable={true}
                            body={props.disableStyleInstrumentTemplate}
                        />
                        {
                            !props.readOnly &&
                            <Column
                                field="aforo"
                                header="% Aforo"
                                style={{textAlign: 'right'}}
                                body={props.disableStyleInstrumentCapacityTemplate}
                                sortable={true}/>
                        }
                        <Column
                            field="titulos"
                            header="Garantías"
                            style={{textAlign: 'right'}}
                            body={props.disableStyleInstrumentNumberTemplate}
                            sortable={true}/>
                        <Column
                            field={props.isPrecio24Hrs ? "precioDescontado" : "precioValDescontado"}
                            header="Precio Desc."
                            style={{textAlign: 'right'}}
                            body={props.disableStyleInstrumentPriceTemplate}
                            sortable={true}/>
                        <Column
                            field={props.isPrecio24Hrs ? "precioMercado" : "precioVal"}
                            header="Precio Mercado"
                            style={{textAlign: 'right'}}
                            body={props.disableStyleInstrumentPriceTemplate}
                            sortable={true}/>
                        {
                            !props.readOnly &&
                            <Column
                                field="suggested"
                                header="Sugerido"
                                body={props.disableStyleInstrumentNumberTemplate}
                                style={{textAlign: 'right'}}
                                sortable={true}/>
                        }
                        {
                            !props.readOnly &&
                            <Column
                                field="newTitles"
                                header="Títulos"
                                body={props.disableStyleInstrumentNumberTemplate}
                                editor={props.numberEditor}
                                style={{textAlign: 'right'}}
                                sortable={true}/>
                        }
                        <Column
                            field="guaranteeAmount"
                            header="Importe Garantizado"
                            body={props.disableStyleInstrumentAmountTemplate}
                            style={{textAlign: 'right'}}
                            sortable={true}/>
                        <Column
                            field="marketAmount"
                            header="Importe Mercado"
                            body={props.disableStyleInstrumentAmountTemplate}
                            style={{textAlign: 'right'}}
                            sortable={true}/>
                    </DataTable>
                </Grid>
            </Grid>
        </React.Fragment>
    )
};

export default GuaranteeForChange;